import {createSelector} from 'reselect';
import {ProtocolExplorerAccordionGroup} from 'constants/protocolExplorerEnum';

export const getProtocolExplorerState = (state) => state.protocolExplorerState;

export const getCurrentProtocolFolder = (state) => state.protocolExplorerState.currentProtocolFolder;

export const getProtocolOrFolderSelected = (state) => state.protocolExplorerState.selectedProtocolOrFolderIDs;

export const getProtocolClipboardEventType = (state) => state.protocolExplorerState.protocolClipboardEventType;

export const getProtocolClipboardItems = (state) => state.protocolExplorerState.protocolClipboardItems;

export const getProtocolFolderList = (state) => state.protocolExplorerState.protocolFolderList;

export const getRunningProtocol = (state) => state.protocolExplorerState.runningProtocol;

export const getExpandedGroups = (state) => state.protocolExplorerState.expandedGroups;

export const getExpandedItemsArr = createSelector(
  [
    getExpandedGroups,
    (state, favoriteProtocolsCount, foldersCount, protocolsCount) => ({
      favoriteProtocolsCount,
      foldersCount,
      protocolsCount,
    }),
  ],
  (expandedGroups, {favoriteProtocolsCount, foldersCount, protocolsCount}) => {
    if (!expandedGroups) return [];

    const keys = [];
    if (favoriteProtocolsCount) keys.push(ProtocolExplorerAccordionGroup.FAVORITE_PROTOCOLS);
    if (foldersCount) keys.push(ProtocolExplorerAccordionGroup.FOLDERS);
    if (protocolsCount) keys.push(ProtocolExplorerAccordionGroup.PROTOCOLS);

    const expandedItems = keys.map((key) => expandedGroups[key]);

    // add default value on the rest of array
    while (expandedItems.length < Object.keys(expandedGroups).length) {
      expandedItems.push(true);
    }

    return expandedItems;
  },
);

export const getSelectedProtocolAndFolderIds = (state) => state.protocolExplorerState.selectedProtocolOrFolderIDs;

export const selectProtocolExplorerDefaultViewSettings = (state) => state.protocolExplorerState.defaultViewSettings;

export const selectProtocolExplorerItems = (state) => state.protocolExplorerState.explorerItems;

export const selectTrayBoundProtocolsIDs = (state) => state.protocolExplorerState.trayBoundProtocolIDs;

export const selectProtocolExplorerActiveFilter = (state) => state.protocolExplorerState.activeFilter;

export const selectProtocolExplorerActiveSort = (state) => state.protocolExplorerState.activeSort;

export const selectRunningProtocolName = (state) => state.protocolExplorerState.runningProtocol?.user?.name;
